import { browser } from '../agent';

export const isCtrlKeyDown = (e): boolean => {
    if (!browser.isMobile) {
        if (e && ((browser.isMac && e.metaKey) || (!browser.isMac && e.ctrlKey))) {
            return true;
        }
        return false;
    }
    return false;
};
